import PropTypes from "prop-types";
import React from "react";
import { FormattedDate } from "react-intl";

/**
 * A provisioned subscription's date, or a dash when it has none.
 *
 * @param {Object} props Component props.
 *
 * @returns {JSX.Element|string} The formatted date or the dash.
 */
function ProvisionedDate( { value = null } ) {
	if ( ! value ) {
		return "—";
	}
	return <FormattedDate value={ value } year="numeric" month="short" day="numeric" />;
}

ProvisionedDate.propTypes = {
	value: PropTypes.instanceOf( Date ),
};

export default ProvisionedDate;
